// extracted by mini-css-extract-plugin
export default {"AssignChecklist":"AddStaffClient_AssignChecklist__QOenJ","modalBody":"AddStaffClient_modalBody__eaFdJ","formControl":"AddStaffClient_formControl__IDsTB"};